export class SmallscreenSearchActiveEvent {
    static EVENT_NAME = 'smallscreen-search-active';
}
